let cached: AudioContext | null = null;

export function getAudioContext(): AudioContext {
  if (cached === null) {
    cached = new AudioContext();
  }
  return cached;
}

export async function resumeAudioContext(): Promise<void> {
  const ctx = getAudioContext();
  if (ctx.state === 'suspended') {
    await ctx.resume();
  }
}
